import { render, staticRenderFns } from "./embarazo.vue?vue&type=template&id=c0e9e74e&scoped=true"
import script from "./embarazo.vue?vue&type=script&lang=js"
export * from "./embarazo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e9e74e",
  null
  
)

export default component.exports